import React from "react";

import Info from "./Info";

import EditCard from "uicomponents/EditCard";

import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { AppDocumentType, EPLIType } from "types";

interface IEPLIReviewProps {
  data: EPLIType;
  setActiveStepIndex: (index: number) => void;
  sectionNumber: number;
  documents: AppDocumentType;
}

type TDataEntries = [keyof EPLIType, string];

const EPLIReview = ({
  data,
  setActiveStepIndex,
  sectionNumber,
  documents,
}: IEPLIReviewProps): JSX.Element => {
  if (!data) {
    return <></>;
  }

  const questions = Object.entries(
    sectionsQuestions.epli.questions
  ) as TDataEntries[];

  return (
    <EditCard
      title={`${sectionsQuestions.epli.title}`}
      onEditClick={() => setActiveStepIndex(sectionNumber)}
    >
      {questions.map(([key, value]) => {
        if (key === "epliDocument") {
          return (
            <Info
              key={key}
              question={value}
              answer={
                documents?.find((item) => item.applicationField === key)
                  ?.fileName
              }
              questionFieldName={key}
            />
          );
        }

        if (key === "epliLossDocument") {
          return (
            <Info
              key={key}
              question={value}
              answer={
                documents?.find((item) => item.applicationField === key)
                  ?.fileName
              }
              questionFieldName={key}
            />
          );
        }
        return (
          <Info
            key={key}
            question={value}
            answer={data?.companyInformation?.epli?.[key]}
            questionFieldName={key}
          />
        );
      })}
    </EditCard>
  );
};

export default EPLIReview;
